const RichTextUX = () => {
    if ($('.section-laika-rich-text').length <= 0) return null;

    $('.section-laika-rich-text').each(function() {
        
    const $parent = $(this);
    const $tooltipToggle = $parent.find('.tooltip-toggle');

    const $tooltipPopupDesk = $parent.find('.inner-wrapper .tooltip-content');
    
    const $tooltipCloseDesk = $parent.find('.close-tooltip-popup.desk');
    const $tooltipCloseMob = $parent.find('.close-tooltip-popup.mob');
    
    $tooltipToggle.click(function() {
        //desktop
        if ($(window).width() > 1200) {
            $(this).closest('.tooltip-group').toggleClass('active')
            $tooltipPopupDesk.stop().fadeToggle(300); 
        } else {
            $parent.find('.mobile-tooltip-popups').fadeIn(300);
        }
    })

    //close desktop
    $tooltipCloseDesk.click(function() {
        $(this).closest('.tooltip-content').stop().fadeOut(300);
        $(this).closest('.tooltip-group').removeClass('active');
    })

    //close mobile
    $tooltipCloseMob.click(function() {
        $(this).closest('.mobile-tooltip-popups').fadeOut(300);
    })
    })
}

export default RichTextUX